import { useCallback } from "react";

import { LayerAlias } from "constant";
import useDeleteMarker from "hooks/useDeleteMarker";

import { useMapContext } from "context/MapContextProvider";

import MoveIcon from "assets/icons/move.svg";
import DeleteIcon from "assets/icons/trash.svg";

import styles from "./map-marker-context-menu.module.scss";

const MapMarkerContextMenu = ({ marker, onMove }) => {
  const onDeleteMarker = useDeleteMarker();
  const { closeContextMenu } = useMapContext();

  const onDeleteMarkerClick = useCallback(() => {
    closeContextMenu();
    onDeleteMarker(marker.id, LayerAlias.MANUAL)();
  }, [onDeleteMarker, marker.id, closeContextMenu]);

  return (
    <div className={styles["context-menu-container"]}>
      <h4 className={styles["context-menu-name"]}>{marker.name}</h4>
      <div className={styles["divider"]} />
      <div className={styles["context-menu-coordinates"]}>
        {marker.geo_data.coordinates[0]} N {marker.geo_data.coordinates[1]} E
      </div>
      <div className={styles["option"]} onClick={onMove}>
        <div className={styles["option-icon"]}>
          <img src={MoveIcon} alt="move" />
        </div>
        Move
      </div>
      <div className={styles["option"]} onClick={onDeleteMarkerClick}>
        <div className={styles["option-icon"]}>
          <img src={DeleteIcon} alt="delete" />
        </div>
        Delete
      </div>
      <div className={styles["divider"]} />
    </div>
  );
};

export default MapMarkerContextMenu;
